"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardSystem = void 0;
const InputSystem_1 = require("../InputSystem");
class KeyboardSystem extends InputSystem_1.InputSystem {
    constructor(state) {
        super(state);
        this.actionsQueued = [];
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        window.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener('keyup', this.handleKeyUp);
    }
    updateState() {
        this.actionsQueued.forEach(({ action, value }) => {
            this.actionState[action] = value;
        });
        this.actionsQueued.length = 0;
    }
    handleKeyDown(event) {
        const actions = this.resolveActions(event.code);
        actions && this.actionsQueued.push(...actions.map(action => { return { action, value: true }; }));
    }
    handleKeyUp(event) {
        const actions = this.resolveActions(event.code);
        actions && this.actionsQueued.push(...actions.map(action => { return { action, value: false }; }));
    }
    onClear() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
    }
}
exports.KeyboardSystem = KeyboardSystem;
//# sourceMappingURL=module.js.map